import { render, staticRenderFns } from "./CustomerIndex.vue?vue&type=template&id=51191ba0&scoped=true&"
import script from "./CustomerIndex.vue?vue&type=script&lang=ts&"
export * from "./CustomerIndex.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerIndex.vue?vue&type=style&index=0&id=51191ba0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51191ba0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VIcon,VPagination,VRow,VSimpleTable,VSkeletonLoader,VTextField})
